import { render, staticRenderFns } from "./CollectivePrint.vue?vue&type=template&id=260899f0&scoped=true"
import script from "./CollectivePrint.vue?vue&type=script&lang=js"
export * from "./CollectivePrint.vue?vue&type=script&lang=js"
import style0 from "./CollectivePrint.vue?vue&type=style&index=0&id=260899f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260899f0",
  null
  
)

export default component.exports